import React from "react";
import { IconProps } from "../icon";

export const ImageUserUpIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 5l3-3m0 0l3 3m-3-3v6m3 4v5.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C4.28 2 5.12 2 6.8 2H12M2.146 19.926A4.002 4.002 0 016 17h7c.93 0 1.394 0 1.78.077a4 4 0 013.143 3.143c.077.386.077.85.077 1.78M14 9.5a4 4 0 11-8 0 4 4 0 018 0z"
    />
  </svg>
);
